/* eslint-disable no-shadow */

import { seatingApi } from '@/app/shared/services/apis/seatingApi.service';

const initialState = {
    venue: null,
    seatPlanTypes: [],
    seatPlan: null,
};

const state = () => ({ ...initialState });

const getters = {
    venueId(state) {
        return state.venue?.id ?? null;
    },
    seatPlanId(state) {
        return state.seatPlan?.id ?? null;
    },
    seatPlan(state) {
        return state.seatPlan ?? null;
    },
};

const actions = {
    async loadData({ commit, dispatch }, { venueId, seatPlanId }) {
        const [venueResponse, venueSeatPlanTypesResponse] = await Promise.all([
            seatingApi.getVenue(venueId),
            seatingApi.getSeatPlanTypes(),
        ]);

        commit('setVenue', venueResponse.data);
        commit('setSeatPlanTypes', venueSeatPlanTypesResponse.data);

        if (seatPlanId) {
            await dispatch('loadSeatPlan', { venueId, seatPlanId });
        }
    },
    async loadSeatPlan({ commit }, { venueId, seatPlanId }) {
        const seatPlanResponse = await seatingApi.getEditorSeatPlan(venueId, seatPlanId);
        commit('setSeatPlan', seatPlanResponse.data);
    },
    async reloadSeatPlan({ getters, dispatch }) {
        await dispatch('loadSeatPlan', {
            venueId: getters.venueId,
            seatPlanId: getters.seatPlanId,
        });
    },
};

const mutations = {
    setVenue(state, venue) {
        state.venue = venue;
    },
    setSeatPlanTypes(state, seatPlanTypes) {
        state.seatPlanTypes = seatPlanTypes;
    },
    setSeatPlan(state, seatPlan) {
        state.seatPlan = seatPlan;
    },
    removeSeat(state, { seatId }) {
        state.seatPlan = {
            ...state.seatPlan,
            blocks: state.seatPlan.blocks.map((block) => ({
                ...block,
                rows: block.rows.map((row) => ({
                    ...row,
                    seats: row.seats.filter((seat) => seat.id !== seatId),
                })),
            })),
        };
    },
    removeSeatsByIds(state, seatIds) {
        state.seatPlan = {
            ...state.seatPlan,
            blocks: state.seatPlan.blocks.map((block) => ({
                ...block,
                rows: block.rows.map((row) => ({
                    ...row,
                    seats: row.seats.filter((seat) => !seatIds.includes(seat.id)),
                })),
            })),
        };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
